export enum AutoSaveStatus {
  NoSave = 1,
  SaveSuccessful = 2,
  SaveUnsuccessful = 3,
  SaveRetry = 4,
  Saving = 5,
}
